import axios from 'axios';

/**
 * 获取阵列位移计设备源列表
 */
export const getDeviceSources = () => {
  return axios.get('/api/deviceSources');
};


/**
 * 删除设备源
 */
export const deleteDeviceSource = (params) => {
  return axios.delete(`/api/deviceSources/${params.id}`);
};


/**
 * 『不挂载』测试阵列位移计
 */
export const deviceSourceTest = (params) => {
  return axios.post('/api/test/adm', params);
};


/**
 * 『不挂载』测试前设置阵列位移计布设模式及读取模式
 */
export const deviceSourceSetMode = (params) => {
  return axios.post('/api/test/adm-set-mode', params);
};

